import Select2 from 'select2'
import Select2Es from 'select2/dist/js/i18n/es'
import Select2PtBr from 'select2/dist/js/i18n/pt-BR'
import Select2En from 'select2/dist/js/i18n/en'

// Configuração padrão para Select2: "ocupe toda a largura".
// Facilita uso de Grid.
$.fn.select2.defaults.set('width', '100%')
